<template>
  <div class="wrapper">
    <div class="attention">
      <img
        src="@/assets/icon_exclamation@.png"
        alt="エラー"
        width="22"
        height="86"
      />
    </div>
    <h2>お探しのページが見つかりませんでした。</h2>
    <p>
      KEIAIミツカルをご利用いただきありがとうございます。アクセスいただいたページはみつかりませんでした。TOPページへ戻り、引き続き検索をお楽しみください。
    </p>
      <div class="button">
        <a class="button__confirm" href="/">
          TOPページへ
        </a>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Error',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
    };
  },
  mounted() {
    // Footer表示フラグ更新
    this.$store.commit('setFooterDisplayFlag');
  },
  mixins: [],
};
</script>
<style scoped lang="scss">
@charset "UTF-8";
h2 {
    font-size: 16px;
    font-weight: bold;
    margin: 40px auto 19px;
    text-align: center;
}
p {
  font-size: 14px;
  margin: auto;
  padding-bottom: 40px;
  max-width: 610px;
  line-height: 2em;
}
div.attention {
  text-align: center;
}
.wrapper {
  padding: 112px 20px;
  background-color: #F6F6F6;
}
.button {
  display:flex;
  justify-content: center;
  align-items: center;
  // margin-top:50px;
  a {
    height: 55px;
    width: 352px;
    font-size: 18px;
    border-radius: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight:bold;
  }
  &__back {
    width:152px;
    border: 1px solid #CCC;
    background-color:#FFF;
    position: absolute;
    left:0;
  }
  &__confirm {
    color: #FFF;
    width: 264px;
    background-color: #E83532;
  }
}
</style>
